<template>
  <Popover placement="bottom" :width="350">
    <div title="Filter Books" class="drop-down-button" v-bind:class="{'alpha' : filterAlpha}">
        <i class="fal fa-book"></i>
    </div>
    <div slot="content">
      <div class="filter-tools-fixed">
          <div class="drop-down-filter-header">
            <h3 class="filter-header">Filter Books</h3>
            <span class="filter-select-all-text" v-on:click="selectAll()">{{selectAllText}}</span>
            <div style="clear: both;"></div>
          </div>
          <Search v-on:searcher="onSearch" :placeholder="'Search books'" />
      </div>

      <div class="filter-content">
          <slot v-for="(book, i) in bookFilterSearchList">
          <div v-if="book.items" v-bind:key="i" class="list-item" @click="book.filteredIn = !book.filteredIn; bookFilterChanged(book.id);">
            <span class="list-item-title" style="width: calc(100% - 50px);">
              <img style="display: inline-block" :for="book.id" :src="$config.get('ecApi') + 'web/books/' + book.id + '/cover?width=200'" alt="coverImage" width="50">
              <div class="book-title">{{book.title}}</div>
            </span>
            <input class="filter-checkbox is-pulled-right" type="checkbox" name="book" :id="book.id" @change="bookFilterChanged(book.id)" v-model="book.filteredIn" style="margin-top: 28px;" />
          </div>
          </slot>
      </div>
    </div>
  </Popover>
</template>

<script>
  const _ = require('lodash');
  import Vue from 'vue';
  
  import utils from '@/utils/utils.js';
  import Popover from '../popover';
  import storeHelpers from '@/utils/storeHelpers.js';
  import Search from '../Search';

  export default {
    name: 'BookFilter',
    components: {
      Popover,
      Search
    },
    data: function () {
      return {
        utils: utils,
        error: '',
        search: '',
        selectAllText: 'Deselect all',
        filterAlpha: false
      }
    },
    props: [
      'books', 'cache', 'popupOptions', 'booksById'
    ],
    mounted: function () {
    },
    computed: {
      bookFilterSearchList() {
        return this.books.filter(book => {
          return book.title.toLowerCase().includes(this.search.toLowerCase()) && book.items.length > 0
        })
      }
    },    
    methods: {
      onSearch: function(val) {
        this.search = val;
      },
      calculateFilterButtonText: function () {
        var t = this;

        var allFilteredIn = _.countBy(t.books, 'filteredIn')['true'] === t.books.length;
        this.filterAlpha = allFilteredIn ? false : true;
        return allFilteredIn ? "Deselect all" : "Reset filters";
      },
      selectAll: function () {
        var t = this;

        if (t.selectAllText === "Deselect all") {
          _.each(t.books, function(book) {
            Vue.set(book, 'filteredIn', false);
            t.cache.booksFilteredOut.add(book.id);
          });
        } else {
          t.cache.booksFilteredOut.clear();
          _.each(t.books, function(book) {
            Vue.set(book, 'filteredIn', true);
          });
        }

        t.selectAllText = t.calculateFilterButtonText();
      },
      bookFilterChanged: function(bookid) {
        var t = this;
        if (!t.booksById[bookid].filteredIn) {
          t.cache.booksFilteredOut.add(bookid)
        } else {
          t.cache.booksFilteredOut.delete(bookid)
        }
        t.selectAllText = t.calculateFilterButtonText();
      }
    }
  }
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.filter-content img {
  height: 65px !important;
}

.filter-content .book-title {
  display: inline-block; 
  overflow: hidden; 
  width: 60%;
  vertical-align: top; 
  text-overflow: ellipsis;
  margin-top: 20px;
  margin-left: 10px;
}

.filter-content {
  height: 45vh;
}

.alpha {
  color: rgba(0, 0, 0, 0.3);
}

.list-item-title {
  text-overflow: ellipsis;
}

@media only screen and (max-width: 600px) {
  .book-cover {
    display: none;
  }
  .filter-content .book-title {
    width: 76%;
  }
  .list-item-title {
    text-overflow: ellipsis;
    width: calc(100% - 100px) !important;
  }
  .list-item {
    width: 100%;
  }
  .list-item-title {
    width: calc(100% - 75px) !important;
  }
}
</style>